import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    setRicette,
    addRicette,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    enumRequestFailure,
    enumRequestStart,
    enumRequestSuccess,
    setTipo
  } from "./ricetteSlice.js";

  import ricetteAPI from "../../services/ricetteApi";
import { toast } from "react-toastify";

  export const fetchRicette = createAsyncThunk(
    "ricetteData/fetchRicette",
    async (_, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await ricetteAPI.getAllRicette();
        dispatch(setRicette(response.data.data));
        console.log(response.data.data, 'data of fetch');
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch prodotti.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );
//   export const singleMezzi = createAsyncThunk(
//     "mezzi/fetchSingleMezzi",
//     async (mezziId, {dispatch}) => {
//       dispatch(apiRequestStart());
//       try {
//         const response = await mezziAPI.getSingleMezzi(mezziId);
//         // Make sure we're storing the data properly in state
//         dispatch(addMezziId([response.data.data]));
//         // Add logging to debug
//         // console.log("Single Prodotto data:", response.data.data);
//         dispatch(apiRequestSuccess());
//         return response.data;
//       } catch (error) {
//         const errorMessage =
//           error.response?.data?.message || "Failed to fetch single prodotto.";
//         dispatch(apiRequestFailure(errorMessage));
//         throw new Error(errorMessage);
//       }
//     }
//   )
  export const createRicette = createAsyncThunk(
    "mezziData/createMezzi",
    async (payload, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await ricetteAPI.createRicette(payload);
        dispatch(addRicette(response.data.data));
        toast.success(response?.data?.message)
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to create prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );
//   export const updateMezziData = createAsyncThunk(
//     "mezziData/updateMezzi",
//     async ({ id, data }, { dispatch }) => {
//       dispatch(apiRequestStart());
//       try {
//         const response = await mezziAPI.updateMezzi(id, data);
//         dispatch(updateMezzi(response.data.data));
//         dispatch(apiRequestSuccess());
//         return response.data;
//       } catch (error) {
//         const errorMessage =
//           error.response?.data?.message || "Failed to update prodotto.";
//         dispatch(apiRequestFailure(errorMessage));
//         throw new Error(errorMessage);
//       }
//     }
//   );
//   export const deleteMezziData = createAsyncThunk(
//     "mezziData/deleteMezzi",
//     async (id, { dispatch }) => {
//       dispatch(apiRequestStart());
//       try {
//         await mezziAPI.deleteMezzi(id);
//         dispatch(deleteMezzi(id));
//         dispatch(apiRequestSuccess());
//         return id;
//       } catch (error) {
//         const errorMessage =
//           error.response?.data?.message || "Failed to delete prodotto.";
//         dispatch(apiRequestFailure(errorMessage));
//         throw new Error(errorMessage);
//       }
//     }
//   );
  export const fetchTipo = createAsyncThunk(
    "mezziData/fetchMezzo",
    async (_, { dispatch }) => {
      dispatch(enumRequestStart("mezzo"));
      try {
        const response = await ricetteAPI.getTipo();
        // console.log("Tipologia API Response:", response.data.data);
        dispatch(setTipo(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("mezzo"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch tipologia.";
        dispatch(
          enumRequestFailure({
            enumType: "mezzo",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );